import script from "./ConfigWarningsIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigWarningsIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigWarningsIndicator.vue?vue&type=style&index=0&id=0c364bbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c364bbc"]])

export default __exports__